type FilterStore<T> = {
	get(): T
	set(updates: Partial<T>): T
	reset(next: T): T
}

// Simple mutable store for filter state; avoids prop-drilling and keeps reads/writes explicit.
export function createFilterStore<T>(initial: T): FilterStore<T> {
	let current = initial

	return {
		get: () => current,
		set: (updates: Partial<T>) => {
			current = { ...current, ...updates }
			return current
		},
		reset: (next: T) => {
			current = next
			return current
		},
	}
}
